<template>
  <div class="priview">
    <div class="priview-title">
      <ElIcons name="CaretLeft" />
      <p>{{ letterForm.title }}</p>
      <ElIcons name="CaretRight" />
    </div>
    <div class="content">
      <img class="bannerImg" :src="letterForm.img" alt="" />
      <div class="content-msg">
        <p v-html="letterMsg"></p>
      </div>
      <div class="content-date">
        <span style="margin-right: 8px;">{{ week }}</span>
        <span> {{ chineseDate }}</span>
      </div>
      <div class="line"></div>
      <div class="content-info">
        <div class="content-info-left">
          <span style="margin-right: 8px;">{{ letterForm.nickName }}</span>
          <span style="margin-right: 8px;">{{ letterForm.city }}</span>
          <div class="content-sex" :class="letterForm.sex == 1?'man':'woman'">
            <ElIcons v-if="letterForm.sex == 1" name="Male" />
            <ElIcons v-else name="Female" />
            <span style="margin-left: 3px;"> {{ letterForm.age }}</span>
          </div>
        </div>
        <div class="content-info-right">
          <span style="margin-right: 6px;">{{ letterForm.id.toString() + letterForm.age.toString()}}</span>
          <img class="zanImg" src="../../../assets/image/zan@2x.png" alt="" />
        </div>
      </div>
    </div>
    <div class="priview-btn">
      去留言
    </div>
  </div>
</template>

<script>
export default {
name: "LetterPreview",
  props: {
    value: Object
  },
  data() {
    return {
      letterForm: this.value.letterForm,
      msg:this.value.letterForm.msg
    }
  },
  computed: {
    letterMsg() {
      let arr = this.msg.split('\n')
      let str = ''
      arr.map(item=> {
        let p = '<p>' + item + '</p>'
        str += p
      })
      return str
    },
    week() {
      let date = new Date(this.value.letterForm.showTime).getDay()
      return date == 0?'星期一':date == 1?'星期二':date == 2?'星期三':date == 3?'星期四':date == 4?'星期五':date == 5?'星期六':'星期日'
    },
    chineseDate() {
      let chinese = ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
      let date = new Date(this.value.letterForm.showTime)
      let m = (date.getMonth() + 1).toString();
      let d = date.getDate().toString();
      let result = ''
      //年
      // for (let i = 0; i < y.length; i++) {
      //   result += chinese[y.charAt(i)];
      // }
      // result += '年';
      //月
      if (m.length == 2) {
        let temp = '十';
        if (m.charAt(1) != '0') {
          temp += chinese[m.charAt(1)];
        }
        result += temp;
      } else {
        result += (chinese[m]);
      }
      result += '月';
      //日
      if (d.length == 2) {
        let temp = '';
        if (d.charAt(0) != '1') {
          temp += chinese[d.charAt(0)];
        }
        temp += '十';
        if (d.charAt(1) != '0') {
          temp += chinese[d.charAt(1)];
        }
        result += temp;
      } else {
        result += (chinese[d]);
      }
      result += '日';
      return result
    }

  }
}
</script>

<style scoped>
.priview {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 24px 0;
}
.priview-title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.priview-title p {
  margin: 0 4px;
}
.content {
  width: 320px;
  border-radius: 10px;
  padding: 0;
  overflow: hidden;
  box-shadow: rgba(0,0,0,.1) 0 8px 16px;
}
.bannerImg {
  width: 100%;
}
.content-msg {
  text-align: center;
  margin: 24px 16px;
  color: #222222;
  font-size: 16px;
  line-height: 1.5;
}
.content-date {
  text-align: right;
  margin-right: 16px;
  font-size: 12px;
  color: #aaaaaa;
}
.line {
  height: 1px;
  margin: 16px;
  background-color: #EDEDED;
}
.content-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #aaaaaa;
  margin: 0 16px 16px;
}
.content-info-left {
  display: flex;
  align-items: center;
}
.content-sex {
  display: flex;
  align-items: center;
  color: #ffffff;
  padding: 1px 6px;
  height: 16px;
  border-radius: 8px;
  scale: 0.8
}
.man {
  background-color: #3a8ee6;
}
.woman {
  background-color: #f54040;
}
.zanImg {
  width: 16px;
  margin-top: -6px;
}
.content-info-right {
  display: flex;
  align-items: center;
}
.priview-btn {
  width: 200px;
  height: 44px;
  border-radius: 22px;
  border: 1px solid #ededed;
  margin-top: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #222222;
}
</style>
